import React from 'react';
import {
  Button,
  Modal,
  Card,
  Col,
  Form,
  Input,
  message,
  DatePicker,
  Row,
  Spin,
  Table,
  Select,
  Tooltip,
} from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { API, BEARER } from '../../constant';
import { indentTypeOptionArray, toProperCase } from '../../utils/generic';
import { getToken } from '../../helpers';
import moment from 'moment';
import { CSVLink } from 'react-csv';
import { useSearchParams } from 'react-router-dom';
import {
  getMonthNameFromStringDate,
  getMonthIndex,
  getDateFromMonth,
  dateFormat,
  monthNames,
} from '../../utils/dateUtils';
import { errorHandler } from '../../utils/errorHandling';

const filterGlobalSearch = (Data, searchText, filterScope) => {
  if (!searchText) {
    return Data;
  }

  let filteredDataTemp = [];
  if (filterScope == 'all') {
    filteredDataTemp = Data.filter((value) => {
      return (
        value?.Indent_file_link?.toLowerCase()?.includes(
          searchText?.toLowerCase()
        ) ||
        value?.Indent_file_reference_id?.toLowerCase()?.includes(
          searchText?.toLowerCase()
        ) ||
        value?.indent_file_date
          ?.toLowerCase()
          ?.includes(searchText?.toLowerCase()) ||
        value?.indent_type?.toLowerCase()?.includes(searchText?.toLowerCase())
      );
    });
  } else if (filterScope == 'Indent_file_link') {
    filteredDataTemp = Data.filter((value) => {
      return value?.Indent_file_link?.toLowerCase()?.includes(
        searchText?.toLowerCase()
      );
    });
  } else if (filterScope == 'Indent_file_reference_id') {
    filteredDataTemp = Data.filter((value) => {
      return value?.Indent_file_reference_id?.toLowerCase()?.includes(
        searchText?.toLowerCase()
      );
    });
  } else if (filterScope == 'indent_file_date') {
    filteredDataTemp = Data.filter((value) => {
      return value?.indent_file_date
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase());
    });
  } else if (filterScope == 'indent_type') {
    filteredDataTemp = Data.filter((value) => {
      return value?.indent_type
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase());
    });
  }

  // Disabled: no need to map supplier to fabric
  //  else if (filterScope == 'suppliers') {
  //   filteredDataTemp = Data.filter((value) => {
  //     return value.supplierDetails.supplierName
  //       .toLowerCase()
  //       .includes(searchText.toLowerCase());
  //   });
  // }

  console.log(filteredDataTemp, 'filtered data', filterScope, searchText);
  if (filteredDataTemp.length > 0) {
    return filteredDataTemp;
  } else {
    filteredDataTemp.push({
      key: 0,
      id: 0,
      Indent_file_link: 'Not Found',
      Indent_file_reference_id: 'Not Found',
      indent_file_date: 'Not Found',
      indent_type: 'Not Found',

      // Disabled: no need to map supplier to fabric
      // supplierDetails: 'Not Found',
    });
    return filteredDataTemp;
  }
};

const IndentMaster = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = parseInt(searchParams.get('page'), 10) || 1;
  const searchString = searchParams?.get('searchquery') ?? '';

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [isDownloading, setIsDownloading] = useState(null);

  // Edit Data for editing existing record
  const [editData, setEditData] = useState(null);
  const [launchMastersList, setLaunchMastersList] = useState([]);

  const [isLoading, setIsLoading] = useState(null);
  const authToken = getToken();
  const [Data, setData] = useState([]);
  const [dataform] = Form.useForm();
  const [showForm, setShowForm] = useState(false);
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pageCount, setPageCount] = useState(0);
  const [total, setTotal] = useState(0);

  //options for form

  const [filterCloumnData, setFilterCloumnData] = useState([]);
  const [filterInfo, setFilterInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState('');

  //filter global
  const [searchText, setSearchText] = useState('');
  const [filterScope, setFilterScope] = useState('all');

  const [alreadySelectedRows, setAlreadySelectedRows] = useState([]);
  const filterScopeOptionsArray = [
    'all',
    'indent_file_date',
    'indent_type',
    'Indent_file_reference_id',

    // Disabled: no need to map supplier to fabric
    // 'suppliers',
  ];

  let data1 = [];

  const fetchData = async (token) => {
    setIsLoading(true);
    try {
      const requestedAdditionalDetails = {
        populate: [
          {
            relation: 'launch_master',
            populate: [
              {
                relation: 'season',
                populate: null,
              },
            ],
          },
        ],
        filters: {
          fieldsFilterConfig: [
            {
              fieldName: 'id',
              path: 'this',
              operation: 'eq',
            },
            {
              fieldName: 'Indent_file_link',
              path: 'this',
              operation: 'containsi',
            },
            {
              fieldName: 'Indent_file_reference_id',
              path: 'this',
              operation: 'containsi',
            },
            {
              fieldName: 'indent_type',
              path: 'this',
              operation: 'containsi',
            },
            {
              fieldName: 'launchName',
              path: 'this.launch_master',
              operation: 'containsi',
            },
            {
              fieldName: 'launchDrop',
              path: 'this.launch_master',
              operation: 'containsi',
            },

            {
              fieldName: 'launchCat',
              path: 'this.launch_master',
              operation: 'containsi',
            },
            {
              fieldName: 'season_id',
              path: 'this.launch_master.season',
              operation: 'containsi',
            },
          ],
          searchString: searchText?.trim()?.toLowerCase() ?? '',
          currentFilter: [
            'id',
            'Indent_file_link',
            'Indent_file_reference_id',
            'indent_type',
            'launchName',
            'launchDrop',
            'launchCat',
            'season_id',
          ],
        },
        sort: {
          createdAt: 'desc',
        },
      };
      const data = { data: { requestedAdditionalDetails } };
      const response = await fetch(`${API}/indent-sheet/get-populated-data`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${BEARER} ${token}`,
        },
        body: JSON.stringify(data),
      });
      const responseData = await response.json();
      console.log('response check --', responseData);
      if (responseData.error) {
        errorHandler(responseData, message);
        // message.error('Something went wrong, please try again');
      } else {
        // return;
        data1 = responseData?.data?.completeSuccess?.map((entry) => {
          // Fetch User Details
          const userDetails = {
            userRefId: entry?.userDetails[0]?.user?.userID,
            userName: entry?.userDetails[0]?.user?.username,
            userEmail: entry?.userDetails[0]?.user?.email,
          };
          // End Fetch User Details

          // console.log(
          //   responseData,
          //   entry.attributes?.launch_master?.data,
          //   'indent check'
          // );

          let launchObj = {};
          if (entry?.launch_master) {
            const launchMasterObject = entry?.launch_master;
            console.log(launchMasterObject, 'check last');
            launchObj = {
              launchRefId: launchMasterObject.id,
              launchName: launchMasterObject.launchName,
              launchCategory: launchMasterObject.launchCat,
              launchMonth: launchMasterObject.launchMonth,
              launchDrop: launchMasterObject.launchDrop,
              launchDate: launchMasterObject.launchDate,
              seasonDetails: {
                seasonId: launchMasterObject?.season?.season_id,
                seasonRefId: launchMasterObject.data?.season?.id,
              },
            };
          }

          return {
            key: entry.id,
            id: entry.id,
            Indent_file_link: entry.Indent_file_link,
            Indent_file_reference_id: entry.Indent_file_reference_id,
            indent_file_date: entry.indent_file_date,
            indent_type: entry.indent_type,
            launch_master: launchObj,
            userDetails: userDetails,
            createdAt: entry?.createdAt,
            updatedAt: entry?.updatedAt,
          };
        });

        console.log('original Data:', responseData);
        console.log('current Data after modification:', data1);
        setData(data1);
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchLaunchList = async (token) => {
    let optionsData2 = [];
    setIsLoading(true);
    try {
      const response = await fetch(
        `${API}/launch-masters?&populate[season][fields][0]=season_id&createdAt:desc`,
        {
          headers: { Authorization: `${BEARER} ${token}` },
        }
      );
      const optionsData = await response.json();

      optionsData2 = optionsData.data.map((entry) => {
        return {
          id: entry.id,
          launchName: entry.attributes.launchName,
          launchDate: entry.attributes.launchDate,
          launchDrop: entry.attributes.launchDrop,
          //   launchCat: entry.attributes.launchCat,

          seasonName: entry.attributes.season?.data?.attributes?.season_id,
          // launch_masters: entry.attributes.launch_masters,
        };
      });

      setLaunchMastersList(optionsData2);
      console.log('original option Data:', optionsData);
      console.log('modified Data:', optionsData2);
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  // Disabled: no need to map supplier to fabric
  // selecting the dropdowns data
  // const fetchSupplier = async (token) => {
  //   let supplierData2 = [];
  //   setIsLoading(true);
  //   try {
  //     const response = await fetch(`${API}/suppler-masters?`, {
  //       headers: { Authorization: `${BEARER} ${token}` },
  //     });
  //     const responseData = await response.json();
  //     console.log(responseData);
  //     if (responseData.error) {
  //       message.error('Something went wrong, please try again');
  //     } else {
  //       supplierData2 = responseData.data.map((entry) => {
  //         return {
  //           id: entry.id,
  //           supplierName: entry.attributes.supplierName,

  //           // launch_masters: entry.attributes.launch_masters,
  //         };
  //       });

  //       setSupplierList(supplierData2);
  //       console.log('original supplier Data:', responseData);
  //       console.log('modified supplier Data:', supplierData2);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     message.error('Error while fetching Data!');
  //   } finally {
  //     setIsLoading(false);
  //   }
  // }; // end function fetchSeason

  useEffect(() => {
    if (authToken) {
      fetchData(authToken);
      fetchLaunchList(authToken);
      // Disabled: no need to map supplier to fabric
    }
  }, []);

  useEffect(() => {
    if (searchText === null) {
      // setSearchParams({ page: 1, searchquery: '' });
    } else if (searchText == '') {
      setSearchParams({ page: 1, searchquery: '' });
      fetchData(authToken);
    } else {
      // let searchParameters = getSearchParameters();
      setSearchParams({ page: currentPage, searchquery: searchText });
      fetchData(authToken);
    }
  }, [searchText, filterScope]);

  // for opening add or edit form with data or change in the reference of data form when form is closed or page is reloaded
  useEffect(() => {
    //dataform data
    console.log(editData);
    dataform.setFieldsValue(editData);
  }, [editData, dataform]);

  // show the modal
  const showModal = () => {
    setIsModalOpen(true);
    dataform.setFieldsValue({ indent_file_date: moment() });
  };

  // hide and reset add/edit form inside modal
  const handleOk = () => {
    dataform.resetFields();
    setEditData(null);
    setIsModalOpen(false);
  };

  // hide and reset add/edit form inside modal
  const handleCancel = () => {
    dataform.resetFields();
    setEditData(null);
    setIsModalOpen(false);
  };

  //add record to database table by api call
  const addNewRecord = async (data) => {
    setSaving(true);

    //add or removing extra data from values from formData object
    const values = {
      ...data,
      indent_file_date: data['indent_file_date'].format('YYYY-MM-DD'),
    };

    data = { data: values };

    console.log('data:', data);
    console.log('values:', values);
    // return;
    //editId will be present only in case of edit mode
    console.log('data edit:', data.data.editEntityId);

    if (data.data.editEntityId) {
      console.log('edit id :', data.data.editEntityId);
      // update the record
      try {
        const response = await fetch(
          `${API}/indent-sheets/${data.data.editEntityId}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',

              Authorization: `Bearer ${getToken()}`,
            },
            body: JSON.stringify(data),
          }
        );
        const responseData = await response.json();
        console.log(responseData);
        if (responseData.error) {
          errorHandler(responseData, message);
        } else {
          message.success('Data saved successfully!');

          fetchData(getToken());
        }
      } catch (error) {
        console.error(Error);
        message.error('Error While Updating the Data!');
      } finally {
        setSaving(false);
        dataform.resetFields();
        setEditData(null);
        setIsModalOpen(false);
      }
    } else {
      // create a new record in the database table
      console.log('edit id:', data.editId); //should be falsy

      try {
        const response = await fetch(`${API}/indent-sheets/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',

            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify(data),
        });
        const responseData = await response.json();
        console.log(responseData);
        if (responseData.error) {
          errorHandler(responseData, message);
        } else {
          message.success('Data saved successfully!');
          //
          fetchData(getToken());
        }
      } catch (error) {
        console.error(Error);
        message.error('Error While Updating the Data!');
      } finally {
        setSaving(false);
        dataform.resetFields();
        setEditData(null);
        setIsModalOpen(false);
      }
    }
  };
  //end function addNewRecord

  const columns = [
    {
      key: 'id',
      title: 'ID',
      dataIndex: 'id',
    },
    {
      key: 'Indent_file_link',
      title: 'Indent File Link',
      render: (_, record) => {
        return (
          <a target="_blank" href={record.Indent_file_link}>
            {record.Indent_file_link}
          </a>
        );
      },
      className: 'antd-column-large',
    },
    {
      key: 'Indent_launch_name',
      title: 'Launch Name',
      dataIndex: 'Indent_launch_name',
      render: (_, record) => record?.launch_master?.launchName,
    },
    {
      key: 'Indent_launch_month',
      title: 'Launch Month',
      dataIndex: 'Indent_launch_month',
      render: (_, record) => record?.launch_master?.launchMonth,
    },
    {
      key: 'Indent_launch_season',
      title: 'Season',
      render: (_, record) => {
        return record?.launch_master?.seasonDetails?.seasonId;
      },
    },

    {
      key: 'Indent_file_reference_id',
      title: 'Indent File Reference id',
      dataIndex: 'Indent_file_reference_id',
    },
    {
      key: 'indent_file_date',
      title: 'indent_file_date',
      dataIndex: 'indent_file_date',
    },
    {
      key: 'indent_type',
      title: 'Indent Type',
      dataIndex: 'indent_type',
    },
    {
      key: 'userName',
      title: 'Username',
      dataIndex: 'userName',
      render: (_, record) => {
        console.log(record, record?.userDetails?.userName);
        return record?.userDetails?.userName ?? 'NA';
      },
    },

    //Disabled: no need to map supplier to fabric
    // {
    //   key: 'suppliers',
    //   title: 'supplier Name',
    //   dataIndex: 'suppliers',
    //   render: (_, record) =>
    //     record.supplierDetails.supplierName
    //       ? record.supplierDetails.supplierName
    //       : 'NA',
    // },
    {
      key: 'action',
      title: 'Actions',

      render: (_, record) => {
        return (
          <div>
            <div className="ActionColumn">
              <EditOutlined
                style={{ color: 'black' }}
                onClick={() => Edit(record)}
              />
              <Button
                icon={
                  <DeleteOutlined style={{ color: 'red', marginRight: 8 }} />
                }
                onClick={() => Delete(record)}
              />
            </div>
          </div>
        );
      },
    },
  ];

  const deleteRecord = async (recordID) => {
    console.log(recordID, 218);
    // return;
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/indent-sheets/${recordID}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',

          Authorization: `Bearer ${getToken()}`,
        },
      });
      const responseData = await response.json();
      console.log(responseData);

      if (responseData.error) {
        errorHandler(responseData, message);
      } else {
        message.success('Successfully Deleted!');
        fetchData(getToken());
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  const Delete = (record) => {
    Modal.confirm({
      title: 'Are you sure you want to delete this',
      onOk: () => {
        deleteRecord(record.id);
      },
    });
  };

  const Edit = (record) => {
    console.log(record, '419');

    // set data for add or edit form
    setEditData({
      Indent_file_link: record.Indent_file_link,
      Indent_file_reference_id: record.Indent_file_reference_id,
      indent_file_date:
        record?.indent_file_date && moment(record?.indent_file_date), // date ,
      indent_type: record.indent_type,
      launch_master: record.launch_master.launchRefId,

      // Disabled: no need to map supplier to fabric
      // suppliers: record.supplierDetails.supplierRefId,
      editEntityId: record.id, // its important for edit functionality
    });
    showModal(); // after setting the data for the edit form show the modal
  };

  const handleTableChange = (pagination, filters, sorter) => {
    console.log('in handle table change', pagination, filters, sorter);
    const { order, columnKey } = sorter;
    setFilterInfo(filters);
    setSortedInfo({ columnKey, order });
    const { current } = pagination;
    setSearchParams({ page: current, searchquery: searchText });
  };

  //reset table
  const resetTable = () => {
    setSortedInfo({});
    setFilterInfo({});
    setSearchText('');
    setFilterScope('all');
    setAlreadySelectedRows([]);
    fetchData(authToken);
  };

  const handleChangeSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleFilterScopeChange = (value) => {
    console.log('setFilterScope', value);
    setFilterScope(value);
  };

  const getFilterOptionArray = (options) => {
    return options.map((option) => {
      return { value: option, label: option };
    });
  };

  const filterOptionArray = [...getFilterOptionArray(filterScopeOptionsArray)];

  const launchListOptions = launchMastersList.map((launch) => {
    return {
      label: launch.launchName,
      value: launch.id,
    };
  });

  const indentTypeOptionList = indentTypeOptionArray.map((value) => {
    return {
      label: toProperCase(value),
      value: value,
    };
  });

  const getFormattedData = () => {
    // setIsLoading(true);
    const downloadData = Data;
    // console.log(downloadData, 'downloading data...');
    // return [];
    let downloadDataFormatted = downloadData?.map((row) => {
      // console.log(row, 'downloading data row...');
      return {
        id: row.id,
        Indent_file_link: row.Indent_file_link,
        'Launch Name': row.launch_master?.launchName,
        'Launch season': row.launch_master?.seasonDetails?.seasonId,
        'Launch Drop': row.launch_master?.launchDrop,
        Indent_file_reference_id: row.Indent_file_reference_id,
        indent_file_date: row.indent_file_date,
        indent_type: row.indent_type,
        userName: row?.userDetails?.userName,
        CreatedDate: moment(row?.createdAt).format('DD/MM/YYYY') ?? 'NA',
      };
    });

    // console.log(downloadDataFormatted, 'downloading data 2...');
    // setIsLoading(false);
    return downloadDataFormatted;
  };

  return (
    <div>
      <h2>Indent Master</h2>
      {/* Modal */}
      <Button onClick={showModal}>Add Indent Master</Button>

      {/* Table Section */}
      <div className="table">
        {/* Filter search Section */}
        <div className="filterContainer">
          <div className="tableSearchSection">
            <Select
              disabled={true}
              defaultValue="all"
              className="filterScopeSelect"
              onChange={handleFilterScopeChange}
              options={filterOptionArray}
            />

            <Input
              placeholder="Enter Search Text"
              onChange={handleChangeSearch}
              type="text"
              allowClear
              value={searchText}
            ></Input>
            <Button onClick={resetTable}>Reset</Button>
            <Button style={{ backgroundColor: 'greenyellow', color: 'white' }}>
              <CSVLink
                data={getFormattedData()}
                filename={
                  'Indent-Master-Records-list-' +
                  moment(new Date()).format('DD-MM-YYYY')
                }
              >
                Download
              </CSVLink>
            </Button>
          </div>
        </div>
        {isLoading ? (
          <Spin size="large" />
        ) : (
          <Table
            loading={isLoading}
            dataSource={Data}
            columns={columns}
            onChange={handleTableChange}
            pagination={{ position: ['bottomCenter'] }}
            rowSelection={{
              type: 'checkbox',
              selectedRowKeys: alreadySelectedRows,
              onChange: (keys) => {
                setAlreadySelectedRows(keys);
              },
              onSelect: (record) => {
                console.log(record, 'selected row ');
              },
              selections: [Table.SELECTION_NONE, Table.SELECTION_ALL],
            }}
          />
        )}
      </div>

      {/* Modal For Add Or Edit */}
      <Modal
        title="Add New Indent Sheet"
        visible={isModalOpen}
        okButtonProps={{ style: { display: 'none' } }}
        cancelButtonProps={{ style: { display: 'none' } }}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1000}
      >
        <Card className="addProduct_page_card">
          <Form form={dataform} layout="vertical" onFinish={addNewRecord}>
            <Row gutter={[16, 16]}>
              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item
                  label="Indent Sheet Link"
                  name="Indent_file_link"
                  rules={[
                    {
                      required: true,
                      message: 'Indent Sheet Link is Required!',
                      type: 'string',
                    },
                  ]}
                >
                  <Input placeholder="Indent Sheet URL" />
                </Form.Item>
              </Col>
              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item
                  label="Indent File Date"
                  name="indent_file_date"
                  rules={[
                    {
                      required: true,
                      message: 'Indent Sheet Date is Required!',
                      type: 'object',
                    },
                  ]}
                >
                  <DatePicker format={dateFormat} disabled={true} />
                </Form.Item>
              </Col>
              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item
                  label="Indent Reference"
                  name="Indent_file_reference_id"
                  rules={[
                    {
                      type: 'string',
                    },
                  ]}
                >
                  <Input placeholder="Indent Reference ID" />
                </Form.Item>
              </Col>

              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item name="indent_type" label="Indent Type">
                  <Select
                    placeholder="Select Indent Type"
                    options={indentTypeOptionList}
                  />
                </Form.Item>
              </Col>

              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item
                  label="Launch Master"
                  name="launch_master"
                  rules={[
                    {
                      required: true,
                      message: 'Launch is Required!',
                    },
                  ]}
                >
                  <Select
                    showSearch
                    onSearch={() => {
                      //
                    }}
                    placeholder="Select "
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label ?? '')
                        .toLowerCase()
                        .includes(input.trim().toLowerCase())
                    }
                    filterSort={(optionA, optionB) =>
                      (optionA?.label ?? '')
                        .toLowerCase()
                        .localeCompare((optionB?.label ?? '').toLowerCase())
                    }
                    options={launchListOptions}
                  />
                </Form.Item>
              </Col>

              <Form.Item label="Username" hidden={true} name="editEntityId">
                <Input type="text" />
              </Form.Item>
            </Row>
            <Button
              className="addProduct_save_btn"
              htmlType="submit"
              type="primary"
              size="large"
            >
              {saving ? (
                <>
                  <Spin size="small" /> Saving
                </>
              ) : (
                'Save'
              )}
            </Button>
          </Form>
        </Card>
      </Modal>
    </div>
  );
};
export default IndentMaster;
